import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage } from "../../features/pagination/paginationSlice";

export default function Pagination() {
	const dispatch = useDispatch();
	const { pages } = useSelector((state) => state.videos);
	const { currentPage } = useSelector((state) => state.pagination);

	const handlePageChange = (page) => {
		dispatch(setCurrentPage(page));
	};

	let content = null;

	if (pages > 0) {
		content = [...Array(pages)].map((value, index) => (
			<div
				key={index}
				className={`cursor-pointer px-4 py-1 rounded-full ${
					currentPage === index + 1
						? "bg-blue-600 text-white "
						: "bg-blue-100 text-blue-600 "
				}`}
				onClick={() => handlePageChange(index + 1)}
			>
				{index + 1}
			</div>
		));
	}

	return (
		<section className="pt-12">
			<div className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex gap-2 justify-end">
				{content}
			</div>
		</section>
	);
}
